import React from 'react';
import styled from 'styled-components';

const ITEMS = [
  'FULL STACK DEVELOPER',
  'REACT',
  'NEXT.JS',
  'NODE.JS',
  'AWS',
  'SPRING BOOT',
  'OPEN TO WORK',
  'BENGALURU',
  'SDE',
];

const Strip = styled.div`
  width: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.primary || '#22D3EE'};
  padding: 11px 0;
  position: relative;
  z-index: 1;
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  animation: marquee-left 22s linear infinite;
  gap: 0;
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 22px;
  padding: 0 28px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #07071A;
  white-space: nowrap;

  &::after {
    content: '✦';
    font-size: 8px;
    opacity: 0.6;
  }
`;

const TickerStrip = () => {
  const duped = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];

  return (
    <Strip>
      <Track>
        {duped.map((item, i) => (
          <Item key={i}>{item}</Item>
        ))}
      </Track>
    </Strip>
  );
};

export default TickerStrip;
